import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import type { TrackingLinkModel } from '@models/types'

interface TrackingLinkProps {
  trackingLink: TrackingLinkModel,
}

const TrackingLink = (props: TrackingLinkProps) => {
  const {
    trackingLink: { title, url },
  } = props

  return (
    <DashboardModuleListItem boxProps={{ paddingY: 'medium' }} title={title}>
      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          href={url}
          marginRight="medium"
          target="_blank"
          type="link"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default TrackingLink
